module.exports = __webpack_public_path__ + "img/Rectangle16.2a017f6f.png";